import { render, staticRenderFns } from "./SurgeryOther.vue?vue&type=template&id=2885efa3&scoped=true"
import script from "./SurgeryOther.vue?vue&type=script&lang=js"
export * from "./SurgeryOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885efa3",
  null
  
)

export default component.exports